// services/sys-user-role.service.ts
import axios from "../../department-viags/config.service";

const BASE = "/api/qltl/sysuserrole";

type ApiResponse<T> = { data: T; statusCode: number };

// Tùy hệ thống của bạn, có thể mở rộng thêm field
export interface UserRole {
  id: string; // Guid
  userId: string; // Guid
  roleId: string; // Guid
  roleCode?: string;
  roleName?: string;
}

export interface UserRoleRequest {
  targetUserId: string; // user được gán/quản lý
  roleIds: string[]; // danh sách role Id
}

export interface CheckExistUserRole {
  userId: string;
  roleId: string;
}

export interface UserInRole {
  id: string;
  hrId: number;
  username: string;
  email: string;
  phoneNumber: string;
  fullName: string;
  avatar: string;
}

export interface CreateUserRole {
  userId: string;
  roleId: string;
}

export interface GetListAccount {
  keyword?: string;
  pageIndex?: number;
  pageSize?: number;
}

export class SysUserRoleService {
  /**
   * POST /CreateUserRoles
   * body: UserRoleRequest
   */
  static async createUserRoles(req: CreateUserRole) {
    const res = await axios.post<ApiResponse<UserRole[]>>(`/qltl/sysuserrole/createuserroles`, req);
    if (res.data.statusCode !== 200) return;
    return res.data.data;
  }

  /**
   * GET /GetUserRoles?targetUserId={id}
   */
  static async getUserRoles(targetUserId: string) {
    try {
      const res = await axios.get<ApiResponse<UserRole[]>>(`${BASE}/GetUserRoles`, { params: { targetUserId } });
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * DELETE /DeleteUserRole/{id}
   * id: Guid của bản ghi UserRole (không phải roleId)
   */
  static async deleteUserRole(id: string) {
    const res = await axios.delete<ApiResponse<boolean>>(`/qltl/sysuserrole/DeleteUserRole/${id}`);
    if (res.data.statusCode !== 200) return;
    return res.data.data;
  }

  /**
   * POST /CheckExistUserRole
   * body: UserRoleRequest
   * return: boolean (giả định)
   */
  static async checkExistUserRole(req: CheckExistUserRole) {
    const res = await axios.post<ApiResponse<string>>(`/qltl/sysuserrole/checkexistuserrole`, req);
    console.log("🚀 ~ SysUserRoleService ~ checkExistUserRole ~ res:", res);
    if (res.data.statusCode !== 200) return;
    return res.data.data;
  }

  static async getListUsersInRole(roleId: string) {
    const res = await axios.get<ApiResponse<UserInRole[]>>(`/qltl/sysuserrole/getlistusersinrole`, {
      params: { roleId },
    });
    if (res.data.statusCode !== 200) return;
    return res.data.data;
  }

  static async getListAccount(params: GetListAccount) {
    const res = await axios.get<ApiResponse<UserInRole[]>>(`/qltl/user/getlistaccount`, {
      params: {
        ...params,
        pageIndex: params.pageIndex || 1,
        pageSize: params.pageSize || 50,
      },
    });
    if (res.data.statusCode !== 200) return;
    return res.data.data;
  }
}
